export default __webpack_public_path__ + "static/media/juni_coupon.0b37c6b7.svg";